import React from 'react';

import { loadNotifications, newNotification, saveNotification, getNotification} from "./../../actions/actions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Button from  '@material-ui/core/Button'
import { Redirect } from  "react-router-dom";
import Header from './../Header';
import Footer from './../Footer'
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import NotificationList from './../lists/NotificationList';
import Paper from '@material-ui/core/Paper';


const rows = [
    { id: 'status', numeric: false, disablePadding: false, label: 'Статус' },
    { id: 'kind', numeric: false, disablePadding: false, label: 'Тип' },
    { id: 'last_edited_date', numeric: false, disablePadding: false, label: 'Дата последнего редактирования' },
    { id: 'object_name', numeric: false, disablePadding: false, label: 'Наименование объекта' },
    { id: 'registration_number', numeric: false, disablePadding: false, label: '№ объекта' },
    { id: 'reply_number', numeric: false, disablePadding: false, label: '№ исходящий' },
    { id: 'inspection', numeric: false, disablePadding: false, label: 'Инспекция' },
    { id: 'file', numeric: false, disablePadding: false, label: '' },
    { id: 'id', numeric: true, disablePadding: false, label: '' },

];


export class OrgCabinet extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            redirect: null,
            user: {},
            auth: false,
            notifications: [],
            notification: {}
        }
    }

    createNotification = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        this.props.newNotification(user.token);
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user.role.indexOf('ROLE_BUILD_ORG')>=0||user.role.indexOf('ROLE_BUILD_USER')>=0) {this.setState({auth :true, user: user});}
        this.props.loadNotifications(user.token);
    }

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        if (this.props.redirect !== null) {
            return (<Redirect to={this.props.redirect} />)
        }

        let notifications = this.props.notifications;

        return (
            <div>
                <Header/>
                <Button onClick={this.createNotification}>Создать уведомление</Button>
                <NotificationList items={notifications} title="Уведомления" rows={rows} />
                <Footer />
            </div>);
    }
}


/* loadInspections, newNotification, signNotification, saveNotification, getNotification*/
function select(state, props) {
    const { notifications } = state;
    console.log('SELECT');
    console.log(notifications);
    return {
        notifications: (typeof notifications !== "undefined" && 'data' in notifications) ? notifications.data : [],
        notification: (typeof notifications !== "undefined" && 'data' in notifications) ?  notifications.item : {},
        redirect: (typeof notifications !== "undefined" && 'data' in notifications) ?  notifications.redirect : null
    };
}

OrgCabinet.defaultProps = {
    notifications: [],
    redirect: null
}


function mapDispatch(dispatch) {
    return {
        loadNotifications: bindActionCreators(loadNotifications, dispatch),
        getNotification: bindActionCreators(getNotification, dispatch),
        newNotification: bindActionCreators(newNotification, dispatch),
        saveNotification: bindActionCreators(saveNotification, dispatch),
    };
}


export default connect(select, mapDispatch)(OrgCabinet);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/NotificationsPage.jsx